<template>   
    <div class="z-5 bg-white pa3" style="width:500px;">
        <div>
            <div class="flex justify-between">
                <h3>{{title}}</h3>
                <img @click="$emit('cancel')" class="grow pointer" src="@/assets/img/icon_x.svg"/>   
            </div>
            <div class="mt3 bodyCopy ph1">
                {{description}}
            </div>
                
        </div>
        <TooliabaButton @click="$emit('cancel')" class="w-50 center mt4">Okay, got it!</TooliabaButton>
    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';

export default {
    components: {
        TooliabaButton
    },
    props: {
        title: {
            type: String
        },
        description: {
            type: String
        }
    }
};
</script>
